var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15 3.047v7.219a.97.97 0 0 0 .262.686.952.952 0 0 0 .665.298h5.917a.944.944 0 0 0 .677-.292.964.964 0 0 0 .268-.692v-7.22h-7.79zm2.92 6.562H3.671V4.687h1.4V9.61zm3.347 0h-1.4V4.687h1.4V9.61zM10.175 1.734H7.667v-.328a.66.66 0 0 0-.19-.464.646.646 0 0 0-.46-.192H5.005a.647.647 0 0 0-.417.214.66.66 0 0 0-.167.442v.328H1.825a.323.323 0 0 0-.23.096.33.33 0 0 0 .23.56h8.35a.323.323 0 0 0 .23-.095.33.33 0 0 0-.23-.56z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.f2432448291e215627f69489e62ba61c.svg";
export { ForwardRef as ReactComponent };